module.exports = __webpack_public_path__ + "img/second-place.1986f9b7.png";